var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floatMenu"},[_c('chat-box',{ref:"chatBox",attrs:{"parentObj":this}}),_c('takeNotes'),_c('scrollToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }